import { createContext, useContext, useEffect, useState } from "react";

const WishCtx = createContext(null);
const KEY = "peppa_wishlist";

export function WishlistProvider({ children }) {
    const [items, setItems] = useState(() => {
        try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
    });

    useEffect(() => {
        localStorage.setItem(KEY, JSON.stringify(items));
    }, [items]);

    function has(productId) {
        return items.some((i) => i.product_id === productId);
    }

    function toggle(product) {
        setItems((prev) => {
            if (prev.some((i) => i.product_id === product.id)) {
                return prev.filter((i) => i.product_id !== product.id);
            }
            return [
                ...prev,
                {
                    product_id: product.id,
                    slug: product.slug,
                    name: product.name,
                    price: product.price,
                    image_url: product.image_url,
                    category: product.category,
                },
            ];
        });
    }

    function remove(productId) {
        setItems((prev) => prev.filter((i) => i.product_id !== productId));
    }

    return (
        <WishCtx.Provider value={{ items, has, toggle, remove, count: items.length }}>
            {children}
        </WishCtx.Provider>
    );
}

export function useWishlist() {
    return useContext(WishCtx);
}
